import { getColumnFilter } from "../base/getColumnFilter.js";
const collectFilters = (columns, filters, environment) => {
  return Object.entries(filters).flatMap(([key, artifact]) => {
    const column = columns.get(key);
    if (column === void 0) {
      return [];
    }
    const filter = getColumnFilter(column, artifact, environment);
    return filter !== void 0 ? [filter] : [];
  });
};
export {
  collectFilters
};
//# sourceMappingURL=collectFilters.js.map
